/**
 * 砍价相关
 */
export const strict = false
export const state = () => ({
	/**
	 * 公共获取剩余砍价次数
	 */
	bargainCountConfig: {
		goodsRemainderCount: '', //	今日商品剩余可砍次数
		remainderCount: '' // 今日剩余可砍价总次数
	},
	bargainSellerGoodsInfo: {}
})
export const mutations = {
	SET_BARGAIN_COUNT_CONFIG: (state, config) => {
		state.bargainCountConfig = config
	},
	SET_BARGAIN_GOODS_INFO: (state, info) => {
		state.bargainSellerGoodsInfo = info
	}
}

export const actions = {
	onGetBargainCount({ commit }, params = {}) {
		const p = {
			action: params
		}
		return new Promise((resolve, reject) => {
			this.$api
				.bargainCountConfig(p)
				.then(res => {
					commit('SET_BARGAIN_COUNT_CONFIG', res.data)
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}
export const getters = {
	bargainCountConfig: state => state.bargainCountConfig,
	bargainSellerGoodsInfo: state => state.bargainSellerGoodsInfo
}
